import * as _ from 'lodash';
import { VehicleDeparture } from './vehicle-departure';

import *as moment from 'moment';

export interface IVehicleDeviation {
    nextStop: string;
    nextStopId: number;
    deviation: Deviation;
    measuredAt: Date;
    color: string;
    text: string;
}

export class VehicleDeviation implements IVehicleDeviation {

    nextStop: string;
    nextStopId: number;

    stopName: string;
    stopRef: string;
    nextStopName: string;
    nextStopRef: string;
    sequenceNumber: number;
    deviation: Deviation;
    measuredAt: Date;
    color: string;
    text: string;
    departures: VehicleDeparture[];
    isTimingPoint: boolean;

    constructor(obj: VehicleDeviation | any = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}

export class Deviation {
    early = true;
    hours = 0;
    minutes = 0;
    seconds = 0;

    constructor(deviation: string | number = null) {

        if (!deviation) {
            return;
        }

        if (_.isString(deviation)) {
            const parts = deviation.split(':');
            if (deviation.indexOf('-') >= 0) {
                this.early = false;
            }
            switch (parts.length) {
                case 3:
                    this.hours = Math.abs(parseInt(parts[0], 0));
                    this.minutes = Math.abs(parseInt(parts[1], 0));
                    this.seconds = Math.abs(parseInt(parts[2], 0));
                    break;
                case 2:
                    this.hours = Math.abs(parseInt(parts[0], 0));
                    this.minutes = Math.abs(parseInt(parts[1], 0));
                    break;
                default:
                    break;
            }
        } else {
            if (deviation < 0) {
                this.early = false;
            }

            const duration = moment.duration(deviation, 'seconds');

            this.hours = duration.hours();
            this.minutes = duration.minutes();
            this.seconds = duration.seconds();
        }
    }

    toString(): string {
        let text = '';
        if (!this.early) {
            text += '-';
        }
        if (this.hours > 24) {
            const days = Math.floor(this.hours / 24);
            return `${text}${days}:${('00' + Math.abs(this.hours - (days * 24))).slice(-2)}:${('00' + Math.abs(this.minutes)).slice(-2)}:${('00' + Math.abs(this.seconds)).slice(-2)}`;
        } else {
            return `${text}${('00' + Math.abs(this.hours)).slice(-2)}:${('00' + Math.abs(this.minutes)).slice(-2)}:${('00' + Math.abs(this.seconds)).slice(-2)}`;
        }

    }

    toShortString(): string {
        let text = '';
        if (!this.early) {
            text += '-';
        }

        if (this.hours > 0 && this.hours <= 24) {
            return `> ${this.hours}h`;
        }
        if (this.hours > 24) {
            const days = Math.floor(this.hours / 24);
            return `> ${days}d`;
        }
        return `${text}${('00' + Math.abs(this.minutes)).slice(-2)}:${('00' + Math.abs(this.seconds)).slice(-2)}`;
    }

    getTotalSeconds(): number {
        const seconds: number = Math.abs(this.seconds) + Math.abs((this.minutes * 60)) + Math.abs((this.hours * 60 * 60));
        return this.early ? seconds : seconds * -1;
    }
}
